import api from "@/helpers/api";

const STORAGE_KEY = "selectedFyId";
const LAST_FY_NAME_KEY = "lastFyName";

export const state = {
  financialYears: [],
  selectedFyId: Number(localStorage.getItem(STORAGE_KEY)) || null,
  loading: false,
};

export const getters = {
  selectedFyId: (state) => state.selectedFyId,
  financialYears: (state) => state.financialYears,
  selectedFy: (state) =>
    state.financialYears.find((fy) => fy.id === state.selectedFyId) || null,
};

export const mutations = {
  SET_FINANCIAL_YEARS(state, years) {
    state.financialYears = years;
  },
  SET_SELECTED_FY_ID(state, id) {
    state.selectedFyId = id;
    if (id) {
      localStorage.setItem(STORAGE_KEY, String(id));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  },
  SET_LOADING(state, flag) {
    state.loading = flag;
  },
};

export const actions = {
  async fetchFinancialYears({ commit, state: s }) {
    if (s.loading) return;
    commit("SET_LOADING", true);
    try {
      const { data } = await api.get("/financial-years");
      commit("SET_FINANCIAL_YEARS", data);

      if (data.length === 0) {
        commit("SET_SELECTED_FY_ID", null);
        return;
      }

      // Smart-match by name on company switch
      const lastFyName = localStorage.getItem(LAST_FY_NAME_KEY);
      if (lastFyName) {
        localStorage.removeItem(LAST_FY_NAME_KEY);
        const match = data.find((fy) => fy.name === lastFyName);
        if (match) {
          commit("SET_SELECTED_FY_ID", match.id);
          return;
        }
      }

      // If already has a valid saved selection, keep it
      if (s.selectedFyId && data.find((fy) => fy.id === s.selectedFyId)) {
        return;
      }

      // Default to current FY or first in list
      const current = data.find((fy) => fy.isCurrent);
      commit("SET_SELECTED_FY_ID", current ? current.id : data[0].id);
    } catch (err) {
      console.error("Failed to fetch financial years:", err);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  selectFy({ commit }, fyId) {
    commit("SET_SELECTED_FY_ID", fyId);
  },

  saveLastFyName({ state: s }) {
    const fy = s.financialYears.find((f) => f.id === s.selectedFyId);
    if (fy) {
      localStorage.setItem(LAST_FY_NAME_KEY, fy.name);
    }
  },
};
